import {
  ListCargoClaimsCommand,
  ListCargoClaimsCommandInput,
  ListCargoClaimsCommandOutput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function listCargoClaimService(input: ListCargoClaimsCommandInput) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }
  const client = setupClaimIntakeClient(token);
  const command = new ListCargoClaimsCommand(input);
  const metricsPublisher = new MetricsPublisher("api.getCargoClaimService");

  return await client
    .send(command)
    .then((response: ListCargoClaimsCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
